import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { register as registerSwiper } from 'swiper/element/bundle';
import Swiper from 'swiper';
import { DeviceDetectorService } from 'ngx-device-detector';

import { LightGallerySettings } from 'lightgallery/lg-settings';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import { LightGallery } from 'lightgallery/lightgallery';
import { InitDetail } from 'lightgallery/lg-events';

import { IImage } from '@shared/models/images';
import { IProperty } from '@shared/models/properties';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
// import { setAuthModal } from '@state/auth/auth.actions';
import { selectAuthUser } from '@state/auth/auth.selectors';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-shared-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent
  implements OnInit, AfterViewInit, OnChanges, AfterViewChecked
{
  @Input({ required: true }) property?: IProperty;
  @Input() heights?: {
    xs: number;
    sm?: number;
    md?: number;
    lg: number;
    xl?: number;
  };
  protected height: string = 'auto';
  protected isMobile = false;
  protected shareModalOpen = false;

  protected isLoggedIn = false;
  protected items?: IImage[] = [];
  protected thumbnails?: IImage[] = [];
  protected currentSlide = 1;

  @ViewChild('swiper') swiperRef?: ElementRef;
  protected swiper?: Swiper;

  constructor(
    private store: Store<AppState>,
    private deviceService: DeviceDetectorService
  ) {
    registerSwiper();
  }

  toggleShareModal() {
    this.shareModalOpen = !this.shareModalOpen;
  }

  swiperReady() {
    if (!this.swiperRef?.nativeElement) return;
    this.swiper = this.swiperRef?.nativeElement.swiper;
  }

  ngAfterViewInit() {
    this.swiperReady();
  }

  goPrev() {
    // if (!this.isLoggedIn) {
    //   this.store.dispatch(setAuthModal({ authModal: 'signin' }));
    // } else {
    this.swiper?.slidePrev();
    // }
  }

  goNext() {
    // if (!this.isLoggedIn) {
    //   this.store.dispatch(setAuthModal({ authModal: 'signin' }));
    // } else {
    this.swiper?.slideNext();
    // }
  }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();

    this.store
      .select(selectAuthUser)
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.isLoggedIn = !!user;
      });

    this.items = this.property?.images?.length
      ? this.property?.images
      : [
          {
            uuid: 'no-image',
            thumbnail: {
              url: '/assets/images/property-no-image.svg',
            },
            small: {
              url: '/assets/images/property-no-image.svg',
            },
            medium: {
              url: '/assets/images/property-no-image.svg',
            },
            large: {
              url: '/assets/images/property-no-image.svg',
            },
          },
        ];
    this.setHeight();
  }

  slideChangeHandler(event: any) {
    if (!event || !event.detail || !event.detail[0]) return;
    this.currentSlide = event.detail[0].activeIndex + 1;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setHeight();
  }

  setHeight(): void {
    if (!this.heights) return;
    const width = window.innerWidth;

    if (width > 1200 && this.heights['xl']) {
      this.height = `${this.heights['xl']}px`;
    } else if (width > 992 && this.heights['lg']) {
      this.height = `${this.heights['lg']}px`;
    } else if (width > 768 && this.heights['md']) {
      this.height = `${this.heights['md']}px`;
    } else if (width > 576 && this.heights['sm']) {
      this.height = `${this.heights['sm']}px`;
    } else {
      this.height = `${this.heights['xs']}px`;
    }
  }

  trackByFn(index: number, item: IImage) {
    return item.uuid;
  }

  @ViewChild('lightGalleryRef', { static: false }) lightGalleryRef?: ElementRef;

  private lightGallery!: LightGallery;
  private needRefresh = false;

  protected gallerySettings: LightGallerySettings = {
    download: false,
    thumbnail: true,
    licenseKey: 'DA3968B0-3FFA-4852-ACE9-3D4F9A4D46BA',
    plugins: [lgThumbnail],
  };

  ngOnChanges() {
    if (!this.lightGallery) return;
    this.needRefresh = true;
  }

  ngAfterViewChecked(): void {
    if (this.needRefresh && this.lightGallery) {
      this.lightGallery.refresh();
      this.needRefresh = false;
    }
  }

  onGalleryInit = (detail: InitDetail): void => {
    this.lightGallery = detail.instance;
  };

  handleImageClick() {
    // if (!this.isLoggedIn) {
    //   this.store.dispatch(setAuthModal({ authModal: 'signin' }));
    // } else {
    if (!this.lightGalleryRef) return;
    const firstAnchorElement =
      this.lightGalleryRef.nativeElement.querySelector('a');
    if (firstAnchorElement) {
      firstAnchorElement.click();
    }
    // }
  }
}
